<template>
  <step :context="context" image="/images/rocket.svg" @back="$emit('back')" @submit="submit">
    <template #guideTitle>Choose your Go Live Date!</template>
    <template #guideDescription>
      All Go Live dates for Loyalty XT will occur on Wednesdays only.
      It takes the Revel and Como Team 8 business days to configure & implement your new loyalty program.
      Please select a Wednesday that is 8 business day from today as your Go Live date.
    </template>
    <template #formTitle>Go Live</template>
    <template #form>
      <v-form class="form" v-model="valid" ref="form">
        <!-- Go Live Date -->
        <template>
          <v-alert v-if="isMissingDate()"
              type="info"
              elevation="24"
              color="primary"
          >Please Select a Date</v-alert>
          <v-row justify="center">
            <v-date-picker
                aria-required="true"
                v-model="model.goLiveDate"
                class="mt-4 no-border"
                :allowed-dates="allowedDates"
                :show-current="true"
                show-adjacent-months
                :min="new Date().toISOString().slice(0,10)"
                :max="maxDate().toISOString().slice(0,10)"
                :rules="[rules.required]"
            ></v-date-picker>
          </v-row>
          <form-section class="terms-section">
            <div class="terms mt-4">
            <span>
              By submitting this form, I accept
              <a
                  href="http://app4mobilebiz.wpengine.com/comosense-solution-general-terms.html"
                  target="_blank"
              >Como terms & conditions</a
              >.
<!--              <div>-->
<!--                A Como Expert will get back to you to coordinate activation and-->
<!--                training and to answer any questions you may have.-->
<!--              </div>-->
            </span>
              <div class="grid">
                <v-text-field
                    v-model="model.termsPerson.name"
                    label="Name"
                    placeholder=" "
                    :rules="[rules.required]"
                />
                <v-text-field
                    v-model="model.termsPerson.role"
                    label="Role"
                    placeholder=" "
                    :rules="[rules.required]"
                />
              </div>
            </div>
            <v-dialog
                v-model="showModal"
                max-width="290"
            >
              <v-card>
                <v-card-title>
                </v-card-title>
                <v-card-text class="text-center">
                  The Loyalty XT program will be automatically <b>activated</b> at the selected date.<br/>
                  If you currently use Revel Loyalty, it will be automatically <b>de-activated</b>.<br/>
                  <b>Are You Sure?</b>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                      color="primary"
                      text
                      @click="showModal = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                      color="primary"
                      text
                      @click="submit()"
                  >
                    Yes
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </form-section>
        </template>
      </v-form>
    </template>
  </step>
</template>

<script>
import Step from "../Step";
import displayMixin from "@/mixins/display";
import { addDays,addYears } from 'date-fns';


export default {
  props: ["context"],
  mixins: [displayMixin],
  components: {
    Step
  },
  data() {
    return {
      valid: false,
      showModal: false,
      rules: {
        required: v => !!v || "Field is required",
      },
      missingDate: false,
      model: {
        goLiveDate: null,
        termsPerson: {
          name: null,
          role: null,
        },
        ...this.context.submittedData
      },
      computed: {
        minimalDate: () => addDays(new Date().setUTCHours(0,0,0,0),8),
        maxDate: () => addYears(new Date(),2),
      }
    };
  },
  methods: {
    submit() {
      if(this.model.goLiveDate == null){
        this.missingDate = true;
      }
      else if(this.context.allData && this.context.allData[1] && this.context.allData[1].existingLoyaltyProgram ==='revel' &&
          !this.showModal){
        this.showModal = true;
      }
      else{
        this.showModal = false;
        if (this.$refs.form.validate()) {
          this.$emit("done", {...this.$data.model});
        }
      }
    },
    isMissingDate() {
      return this.missingDate && this.model.goLiveDate === null
    },
    maxDate: () => addYears(new Date(),2),
    allowedDates(val){
      const currentDate = new Date(val + 'T00:00:00');
      return (currentDate >= this.computed.minimalDate() && currentDate.getDay() === 3)},
  }
};
</script>

<style lang="scss" scoped>
.form {
  .general {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 60px;
    #app.mobile & {
      grid-template-columns: 1fr;
    }
  }
  .terms-section {
    .hint {
      #app.mobile & {
        margin-top: 12px;
      }
    }
    .terms {
      span {
        font-size: 9px;
        font-weight: 600;
        font-style: italic;
        line-height: 2;
        letter-spacing: 0.25px;

        a {
          color: #007aff;
        }
      }

      .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 60px;
        max-width: 400px;

        #app.mobile & {
          grid-template-columns: 1fr;
        }
      }
    }
  }

  #app.desktop & {
    ::v-deep .establishments {
      .v-input--radio-group__input > .v-label {
        margin-bottom: -4px !important;
      }
      .v-text-field {
        .v-input__slot {
          width: 200px;
        }
      }
    }
  }
}
</style>
